module.exports = __webpack_public_path__ + "spider.jpg?ea97f2af9c947f22513d3fb9d3a5aa27";